<template>
  <div :class="styleClasses">
    <div
      :style="{ backgroundImage: `url(${src})`}"
      class="RoundAvatar rounded-full bg-grey-light bg-cover h-full w-full"
    />
  </div>
</template>

<script>
/**
 * @module RoundAvatar
 */
export default {
  name: 'RoundAvatar',
  props: {
    src: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'm'
    },
    styled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    styleClasses () {
      return {
        'border border-white rounded-full': this.styled,
        [this.sizeCalculator[1]]: this.styled,
        [this.sizeLocal]: this.size
      }
    },
    sizeLocal () {
      return this.sizeCalculator[0]
    },
    sizeCalculator () {
      switch (this.size) {
        case '2xs':
          return ['w-10 h-10', 'p-1']
        case 'xs':
          return [`w-16 h-16`, 'p-1']
        case 'm':
          return ['w-24 h-24', 'p-2']
        case 'l':
          return ['w-32 h-32', 'p-3']
        case 'xl':
          return ['w-48 h-48', 'p-3']
        default:
          return ['w-24 h-24', 'p-2']
      }
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
